import { ref } from '@nuxtjs/composition-api';
import { useStoryblok } from './useStoryblok';

export function useFetchArticles() {
  const { storyblok } = useStoryblok();
  const articles = ref([]);

  async function fetchArticles({
    categoryUuid = null, topicUuid = null, tags = null, coverImg = false, limit = null
  } = {}) {
    articles.value = await storyblok.getArticles({
      categoryUuid, topicUuid, tags, coverImg, limit,
    });
  }

  return {
    articles,
    fetchArticles
  };
}
